import { breakpoint, body, label, text } from '@carvana/ds-styles';
import styled from 'styled-components';

const PlateState = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;

const InputsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
`;

const StateWrapper = styled.div<{ $wideOnDesktop: boolean }>`
  z-index: 10;
  position: relative;
  min-width: 120px;
  margin-left: 10px;

  & > div {
    position: absolute;
    width: 100%;
  }

  div[role='combobox'] {
    text-align: left;
  }

  & input {
    width: 100%;
    ${label.md};
  }

  div[role='listbox'] {
    min-height: 15rem;
    max-height: 15rem;
    border-radius: 8px;
    overflow-y: scroll;
  }

  div[role='option'] {
    padding: 12px;
    text-align: left;
  }

  @media screen and (min-width: ${breakpoint.sm}) {
    width: ${({ $wideOnDesktop }) => ($wideOnDesktop ? '33%' : '120px')};
  }
`;

const ErrorTextContainer = styled.div`
  ${body.regular.xs}
  color: ${text.critical};
  text-align: left;
`;

export { PlateState, InputsWrapper, StateWrapper, ErrorTextContainer };
